"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgPinterest(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("circle", {
    cx: 11.951,
    cy: 11.951,
    r: 11.951,
    fill: "#FFF",
    fillRule: "nonzero"
  }), React.createElement("path", {
    fill: "inherit",
    d: "M11.99 0C5.368 0 0 5.368 0 11.99c0 5.082 3.158 9.424 7.618 11.171-.108-.947-.197-2.408.04-3.444.217-.937 1.401-5.96 1.401-5.96s-.355-.72-.355-1.777c0-1.668.967-2.91 2.171-2.91 1.026 0 1.52.769 1.52 1.687 0 1.026-.652 2.565-.997 3.996-.286 1.194.602 2.171 1.776 2.171 2.132 0 3.77-2.25 3.77-5.486 0-2.872-2.062-4.876-5.013-4.876-3.415 0-5.418 2.556-5.418 5.201 0 1.026.395 2.132.888 2.734a.357.357 0 01.08.345c-.09.375-.297 1.194-.336 1.362-.05.217-.178.266-.405.158-1.5-.7-2.437-2.882-2.437-4.648 0-3.78 2.743-7.253 7.924-7.253 4.155 0 7.391 2.96 7.391 6.927 0 4.135-2.605 7.46-6.217 7.46-1.213 0-2.358-.63-2.743-1.38l-.75 2.851c-.267 1.046-.997 2.349-1.49 3.148 1.125.346 2.309.533 3.552.533 6.622 0 11.99-5.368 11.99-11.99C23.98 5.368 18.613 0 11.99 0z"
  })));
}

var _default = SvgPinterest;
exports.default = _default;